import RecentSearchPersonCard from "components/searchPage/mainSearchComponents/RecentSearchPersonCard";
import MainSuggestionsComponent from "components/searchPage/suggestionsComponents/MainSuggestionsComponent";
import { useState, useContext, useEffect, useRef } from "react";
import { CurrentUserContext } from "App";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3080";

export default function SearchPage() {
  const { currentUser } = useContext(CurrentUserContext);
  const [searchAgainFlag, setSearchAgainFlag] = useState(false);
  const [recentSearches, setRecentSearches] = useState([]);
  const [searchElements, setSearchElements] = useState(
    "Please Enter A Search Term Above"
  );
  const [searchTerm, setSearchTerm] = useState("");
  const submitButtonRef = useRef();

  // set recent searches based on local storage
  useEffect(() => {
    const savedRecentSearches = localStorage.getItem("recentSearches");
    if (savedRecentSearches) {
      setRecentSearches(JSON.parse(savedRecentSearches));
    } else {
      setRecentSearches([]);
    }
  }, []);

  // search again from an old search
  useEffect(() => {
    if (searchAgainFlag) {
      submitButtonRef.current?.click();
      setSearchAgainFlag(false);
    }
  }, [searchAgainFlag]);

  function removeRecentSearch(e) {
    const filteredSearches = recentSearches.filter((value, index) => {
      return parseInt(e.target.id) !== index;
    });
    localStorage.setItem("recentSearches", JSON.stringify(filteredSearches));
    setRecentSearches(filteredSearches);
  }

  const onFormSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!searchTerm) {
      alert("Please enter a search term.");
      return;
    }

    fetch(`${API_URL}/getSearchResults`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${currentUser.token}`,
      },
      body: JSON.stringify({ searchTerm }),
    })
      .then((r) => r.json())
      .then((r) => {
        setRecentSearches((prevRecentSearches) => {
          const previousSearchesLowercase = prevRecentSearches?.map((prev) =>
            prev.toLowerCase()
          );
          if (previousSearchesLowercase?.includes(searchTerm.toLowerCase())) {
            return [...prevRecentSearches];
          } else {
            localStorage.setItem(
              "recentSearches",
              JSON.stringify([...prevRecentSearches, searchTerm])
            );
            return [...prevRecentSearches, searchTerm];
          }
        });

        if (r.message === "success") {
          const searchResultElements = r.searchResults.map((searchedUser) => {
            return (
              <RecentSearchPersonCard
                key={searchedUser.user_id}
                searchPersonID={searchedUser.user_id}
                username={searchedUser.username}
                avatar={searchedUser.avatar && searchedUser.avatar !== "sampleAvatar.png"
                  ? searchedUser.avatar
                  : undefined}
                following={searchedUser.connection_status === "followed"}
              />
            );
          });
          setSearchElements(searchResultElements);
        } else if (r.message === "No Users Found") {
          setSearchElements(null);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <div id="search" className="search-layout">
      <div id="search-main">
        {/* Search Form CONTAINER */}
        <div className="d-flex w-100" style={{ paddingTop: "0.5rem" }}>
          {/* SEARCH FORM ITSELF */}
          <form
            onSubmit={onFormSubmit}
            className="d-flex align-items-center input-group rounded-4"
            style={{
              backgroundColor: "var(--main-background-purple)",
              border: "1px solid rgba(185,151,255,0.1)",
            }}
            role="search"
          >
            {/* SEARCH - MAGNIFYING GLASS ICON AREA */}
            <span
              className="input-group-text border-0 rounded-4"
              style={{ backgroundColor: "var(--main-background-purple)" }}
            >
              <ion-icon
                name="search-outline"
                style={{
                  color: "var(--main-purple)",
                  fontSize: "1.8rem",
                  "--ionicon-stroke-width": "5rem",
                  padding: ".5rem 1rem",
                }}
              ></ion-icon>
            </span>
            {/* ACTUAL SEARCH BAR AREA */}
            <input
              className="search-input form-control border-0"
              type="search"
              placeholder="Search"
              aria-label="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ maxWidth: "100%" }}
            />
          </form>
          {/* PRESS THIS TO DO THE SEARCH */}
          <button
            className="search-bar-btn btn d-flex justify-content-center align-items-center rounded-3"
            type="button"
            onClick={onFormSubmit}
            style={{
              backgroundColor: "var(--main-purple)",
              padding: ".5rem 1.25rem",
              marginLeft: "0.5rem",
              flexShrink: 0,
            }}
            ref={submitButtonRef}
          >
            {/* SEARCH PERSON ICON */}
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{}}
            >
              <mask
                id="mask0_408_4182"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="var(--chat-gray)" />
              </mask>
              <g mask="url(#mask0_408_4182)">
                <path
                  d="M19 14C18.7167 14 18.4792 13.9042 18.2875 13.7125C18.0958 13.5208 18 13.2833 18 13V11H16C15.7167 11 15.4792 10.9042 15.2875 10.7125C15.0958 10.5208 15 10.2833 15 10C15 9.71667 15.0958 9.47917 15.2875 9.2875C15.4792 9.09583 15.7167 9 16 9H18V7C18 6.71667 18.0958 6.47917 18.2875 6.2875C18.4792 6.09583 18.7167 6 19 6C19.2833 6 19.5208 6.09583 19.7125 6.2875C19.9042 6.47917 20 6.71667 20 7V9H22C22.2833 9 22.5208 9.09583 22.7125 9.2875C22.9042 9.47917 23 9.71667 23 10C23 10.2833 22.9042 10.5208 22.7125 10.7125C22.5208 10.9042 22.2833 11 22 11H20V13C20 13.2833 19.9042 13.5208 19.7125 13.7125C19.5208 13.9042 19.2833 14 19 14ZM9 12C7.9 12 6.95833 11.6083 6.175 10.825C5.39167 10.0417 5 9.1 5 8C5 6.9 5.39167 5.95833 6.175 5.175C6.95833 4.39167 7.9 4 9 4C10.1 4 11.0417 4.39167 11.825 5.175C12.6083 5.95833 13 6.9 13 8C13 9.1 12.6083 10.0417 11.825 10.825C11.0417 11.6083 10.1 12 9 12ZM2 20C1.71667 20 1.47917 19.9042 1.2875 19.7125C1.09583 19.5208 1 19.2833 1 19V17.2C1 16.6333 1.14583 16.1125 1.4375 15.6375C1.72917 15.1625 2.11667 14.8 2.6 14.55C3.63333 14.0333 4.68333 13.6458 5.75 13.3875C6.81667 13.1292 7.9 13 9 13C10.1 13 11.1833 13.1292 12.25 13.3875C13.3167 13.6458 14.3667 14.0333 15.4 14.55C15.8833 14.8 16.2708 15.1625 16.5625 15.6375C16.8542 16.1125 17 16.6333 17 17.2V19C17 19.2833 16.9042 19.5208 16.7125 19.7125C16.5208 19.9042 16.2833 20 16 20H2ZM3 18H15V17.2C15 17.0167 14.9542 16.85 14.8625 16.7C14.7708 16.55 14.65 16.4333 14.5 16.35C13.6 15.9 12.6917 15.5625 11.775 15.3375C10.8583 15.1125 9.93333 15 9 15C8.06667 15 7.14167 15.1125 6.225 15.3375C5.30833 15.5625 4.4 15.9 3.5 16.35C3.35 16.4333 3.22917 16.55 3.1375 16.7C3.04583 16.85 3 17.0167 3 17.2V18ZM9 10C9.55 10 10.0208 9.80417 10.4125 9.4125C10.8042 9.02083 11 8.55 11 8C11 7.45 10.8042 6.97917 10.4125 6.5875C10.0208 6.19583 9.55 6 9 6C8.45 6 7.97917 6.19583 7.5875 6.5875C7.19583 6.97917 7 7.45 7 8C7 8.55 7.19583 9.02083 7.5875 9.4125C7.97917 9.80417 8.45 10 9 10Z"
                  fill="var(--main-black)"
                />
              </g>
            </svg>
          </button>
        </div>
        {/* RECENT SEARCHES AND RESULTS */}
        <div
          id="recentSearches"
          className="d-flex flex-column gap-4 align-items-start justify-content-start mt-5"
          style={{ maxWidth: "100%", width: "100%" }}
        >
          {/* SEARCH RESULTS COMPONENT AREA */}
          <div
            id="searchResults"
            className="d-flex flex-column gap-4 align-items-center justify-items-between"
            style={{ maxWidth: "100%", width: "100%" }}
          >
            {typeof searchElements === "string" ? (
              <p className="text-center w-100" style={{ color: "var(--chat-gray)", fontSize: "1.4rem", marginTop: "2rem" }}>
                {searchElements}
              </p>
            ) : searchElements === null ? (
              <p className="text-center w-100" style={{ color: "var(--chat-gray)", fontSize: "1.4rem", marginTop: "2rem" }}>
                No Results Found
              </p>
            ) : (
              <div className="d-flex flex-column gap-4 align-items-start w-100">
                {searchElements}
              </div>
            )}
          </div>
          <div className="d-flex flex-column gap-3 align-items-center justify-content-center w-100">
            {/* TITLE - RECENT SEARCHES */}
            <div className="text-center">
              <h2
                className="fw-bold"
                style={{ fontSize: "1.6rem", color: "var(--main-purple)" }}
              >
                Recent Searches
              </h2>
            </div>

            {/* LIST OF SEARCHES */}
            {/* THIS WILL EVENTUALLY BE A COMPONENT */}
            <div
              className="d-flex flex-column gap-4 w-100 px-2"
              style={{ maxWidth: "100%" }}
            >
              {recentSearches?.map((element, key) => {
                return (
                  <div
                    className="d-flex align-items-center justify-content-between w-100"
                    key={key}
                  >
                    <span
                      onClick={() => {
                        setSearchTerm(element);
                        setSearchAgainFlag(true);
                      }}
                    >
                      {element}
                    </span>
                    {/* CLOSE BUTTON */}
                    <button
                      id={key}
                      type="button"
                      className="btn-close btn-close-white"
                      aria-label="Close"
                      style={{ color: "var(--main-white)" }}
                      onClick={removeRecentSearch}
                    ></button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* SUGGESTIONS */}
      <MainSuggestionsComponent />
    </div>
  );
}
